import requestLogin from '@/utils/request_login'
import request from '@/utils/request'


// export function login(username, password) {
//   return request({
//     url: '/admin/login',
//     method: 'post',
//     data: {
//       username,
//       password
//     }
//   })
// }

export function login(username, password) {
  return requestLogin({
    url: '/authorization-server/oauth/token?scope=read&grant_type=password',
    method: 'post',
    data: {
      username,
      password
    },
    auth: {
      username: 'admin_hzz',
      password: 'test_secret'
    },
    setHeaders: true
  })
}


export function addList(data) {
  return request({
    url: '/login/index',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/ums-server/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/ums-server/sso/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/ums-server/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/ums-server/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/ums-server/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/ums-server/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/ums-server/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/ums-server/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/ums-server/admin/role/update',
    method: 'post',
    data: data
  })
}
export function memberInfoList(params) {
  return request({
    url: '/ums-server/memberInfo/list',
    method: 'get',
    params: params
  })
}
export function watchMember(id) {
  return request({
    url: '/ums-server/memberInfo/info/' + id,
    method: 'get',
  })
}
export function disable(id, params) {
  return request({
    url: '/memberInfo/updateStatus/' + id,
    method: 'post',
    params: params
  })
}
export function deleteMember(id) {
  return request({
    url: '/memberInfo/updateDeleteStatus/' + id,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js